import { QueueHomePage } from '@repo/ccc-queue-app-lib/src/pages/QueueHomePage.tsx'
import { MainLayout } from '@repo/internal-tools-app-lib/src/lib/MainLayout.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { QueueSideNav } from '../../lib/QueueSideNav.tsx'

export const Route = createFileRoute('/_authenticated/')({
  component: HomeRoute,
})

function HomeRoute() {
  return (
    <MainLayout nav={<QueueSideNav />}>
      <QueueHomePage />
    </MainLayout>
  )
}
